var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconreporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0932 22.875H17.25L16.5 22.125L16.5112 1.875L22.4163 2.91891C22.5382 2.94046 22.6467 3.0094 22.718 3.11067C22.7893 3.21193 22.8176 3.3373 22.7968 3.45938L19.5553 22.485C19.5367 22.5941 19.4801 22.6931 19.3956 22.7645C19.311 22.8358 19.2039 22.875 19.0932 22.875Z",
    fill: "#FDBF44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5112 1.875L16.5 22.125L17.25 22.875H18V2.1382L16.5112 1.875Z",
    fill: "#E6AD3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7812 1.125H1.59375C1.33487 1.125 1.125 1.33487 1.125 1.59375V22.4062C1.125 22.6651 1.33487 22.875 1.59375 22.875H16.7812C17.0401 22.875 17.25 22.6651 17.25 22.4062V1.59375C17.25 1.33487 17.0401 1.125 16.7812 1.125Z",
    fill: "#25B1FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 12H3.9375C3.41973 12 3 12.4197 3 12.9375V14.8125C3 15.3303 3.41973 15.75 3.9375 15.75H5.8125C6.33027 15.75 6.75 15.3303 6.75 14.8125V12.9375C6.75 12.4197 6.33027 12 5.8125 12Z",
    fill: "#FCFEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 17.625H3.9375C3.41973 17.625 3 18.0447 3 18.5625V20.4375C3 20.9553 3.41973 21.375 3.9375 21.375H5.8125C6.33027 21.375 6.75 20.9553 6.75 20.4375V18.5625C6.75 18.0447 6.33027 17.625 5.8125 17.625Z",
    fill: "#FCFEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25004 15.0001C5.20079 15.0001 5.15202 14.9904 5.10653 14.9715C5.06103 14.9527 5.01969 14.9251 4.98486 14.8902L3.85986 13.7652L4.39021 13.2349L5.22885 14.0735L7.21532 11.756L7.78475 12.2441L5.53475 14.8691C5.50112 14.9084 5.45975 14.9402 5.41323 14.9627C5.36672 14.9852 5.31605 14.9978 5.26443 14.9998C5.25964 15.0001 5.25472 15.0001 5.25004 15.0001Z",
    fill: "#80DAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25004 20.6251C5.20079 20.6251 5.15202 20.6154 5.10653 20.5965C5.06103 20.5777 5.01969 20.5501 4.98486 20.5152L3.85986 19.3902L4.39021 18.8599L5.22885 19.6985L7.21532 17.381L7.78475 17.8691L5.53475 20.4941C5.50112 20.5334 5.45975 20.5652 5.41323 20.5877C5.36672 20.6102 5.31605 20.6228 5.26443 20.6248C5.25964 20.6251 5.25472 20.6251 5.25004 20.6251Z",
    fill: "#80DAFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 17.25H14.25V18H8.625V17.25Z",
    fill: "#FCFEFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 19.125H10.5V19.875H8.625V19.125Z",
    fill: "#FCFEFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19.125H14.25V19.875H11.25V19.125Z",
    fill: "#FCFEFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 11.625H14.25V12.375H8.625V11.625Z",
    fill: "#FCFEFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 13.5H10.5V14.25H8.625V13.5Z",
    fill: "#FCFEFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.5H14.25V14.25H11.25V13.5Z",
    fill: "#FCFEFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37031 2.625L6 4.12786L6.28092 5.91145C6.54851 7.36307 7.36274 8.65673 8.55581 9.52584L9.37336 10.128L10.1522 9.56175C11.3612 8.69305 12.187 7.39021 12.4568 5.92617L12.7406 4.12786L9.37031 2.625ZM9.25617 7.39298C9.18585 7.4633 9.09047 7.5028 8.99102 7.5028C8.89158 7.5028 8.7962 7.4633 8.72587 7.39298L7.60087 6.26798L8.13122 5.7375L8.99109 6.59733L10.9759 4.6125L11.5062 5.1428L9.25617 7.39298Z",
    fill: "#FCFEFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 2.25H4.875V3H2.625V2.25Z",
    fill: "#FCFEFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 3.75H4.125V4.5H2.625V3.75Z",
    fill: "#FCFEFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 2.25H14.625V3H13.875V2.25Z",
    fill: "#FCFEFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 2.25H16.125V3H15.375V2.25Z",
    fill: "#FCFEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconreporting);
export default __webpack_public_path__ + "static/media/iconreporting.51b4385d62b96f09ba19e437973a42dc.svg";
export { ForwardRef as ReactComponent };